import { render, staticRenderFns } from "./ListProject.vue?vue&type=template&id=85271d18&scoped=true"
import script from "./ListProject.vue?vue&type=script&lang=js"
export * from "./ListProject.vue?vue&type=script&lang=js"
import style0 from "./ListProject.vue?vue&type=style&index=0&id=85271d18&prod&scoped=true&lang=css"
import style1 from "./ListProject.vue?vue&type=style&index=1&id=85271d18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85271d18",
  null
  
)

export default component.exports